import styled from 'styled-components';

const Title = styled.h2`
  font-size: 2rem;
  margin-bottom: 1rem;
  color: #6e1f2a;
`;

function SectionTitle({ children }) {
  return <Title>{children}</Title>;
}

export default SectionTitle;